function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import AllhomesBreadcrumbs from '@domain-group/fe-co-allhomes-breadcrumbs';
import { usePageViewEvent } from '@domain-group/fe-co-allhomes-analytics';
import { useAllhomesContext } from '@domain-group/fe-co-allhomes-global-context';
import allhomesAgencySearchResultsWrapper from './allhomes-agency-search-results-wrapper';
import ResultPanel from './components/result-panel';
import { getSingleSuburb } from './utils/localities';
import updateLocation from './utils/update-location';
import * as defaults from './utils/defaults';
import * as styles from './allhomes-agency-search-results.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesAgencySearchResults = _ref => {
  var initialLocalities = _ref.localities,
    tab = _ref.tab,
    initialSort = _ref.sort,
    searchPageUrl = _ref.searchPageUrl,
    autocompleteUrl = _ref.autocompleteUrl,
    enquiryEndpoint = _ref.enquiryEndpoint,
    searchResultsUrl = _ref.searchResultsUrl,
    media = _ref.media;
  var firstRender = useRef(true);
  var _useAllhomesContext = useAllhomesContext(),
    localityLookup = _useAllhomesContext.localityLookup;
  var _useState = useState(initialLocalities),
    _useState2 = _slicedToArray(_useState, 2),
    localities = _useState2[0],
    setLocalities = _useState2[1];
  var _useState3 = useState(initialSort),
    _useState4 = _slicedToArray(_useState3, 2),
    sort = _useState4[0],
    setSort = _useState4[1];
  var performSearch = useCallback(async _ref2 => {
    var newLocalities = _ref2.localities,
      newSort = _ref2.sort;
    var resolvedNewLocalities = await localityLookup(newLocalities);
    setLocalities(resolvedNewLocalities);
    setSort(newSort);
  }, [localityLookup, setLocalities, setSort]);
  usePageViewEvent();

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (!firstRender.current) {
      updateLocation({
        searchResultsUrl,
        localities,
        sort
      });
    }
  }, [searchResultsUrl, JSON.stringify(localities), sort]);
  /* eslint-enable react-hooks/exhaustive-deps */

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    }
  }, []);
  var singleSuburb = getSingleSuburb(localities);
  var finalBreadcrumb = {
    text: singleSuburb ? singleSuburb.name : 'Results',
    link: singleSuburb ? "".concat(searchResultsUrl.replace(/\/$/, ''), "/").concat(singleSuburb.slug, "/") : ''
  };
  return ___EmotionJSX("div", null, ___EmotionJSX("div", {
    css: styles.content
  }, ___EmotionJSX(AllhomesBreadcrumbs, {
    css: styles.breadcrumbs,
    items: [{
      text: 'Home',
      link: '//www.allhomes.com.au/'
    }, {
      text: 'Real Estate Agents',
      link: searchPageUrl
    }, finalBreadcrumb]
  })), ___EmotionJSX("div", {
    css: styles.contentDivider
  }), ___EmotionJSX("div", {
    css: styles.content
  }, ___EmotionJSX(ResultPanel, {
    localities: localities,
    tab: tab,
    sort: sort,
    performSearch: performSearch,
    searchPageUrl: searchPageUrl,
    autocompleteUrl: autocompleteUrl,
    enquiryEndpoint: enquiryEndpoint,
    searchResultsUrl: searchResultsUrl,
    media: media
  })));
};
AllhomesAgencySearchResults.propTypes = {
  localities: PropTypes.arrayOf(PropTypes.shape({})),
  tab: PropTypes.oneOf(['agency', 'agent']),
  sort: PropTypes.oneOf(['SOLD', 'SOLD_TOTAL', 'RENTED', 'RENTED_TOTAL', 'DEVELOPMENT', 'DEVELOPMENT_TOTAL']),
  searchPageUrl: PropTypes.string.isRequired,
  autocompleteUrl: PropTypes.string.isRequired,
  enquiryEndpoint: PropTypes.string.isRequired,
  searchResultsUrl: PropTypes.string.isRequired,
  media: PropTypes.shape({})
};
AllhomesAgencySearchResults.defaultProps = {
  localities: [],
  tab: defaults.tab,
  sort: defaults.sort,
  media: {}
};
export default allhomesAgencySearchResultsWrapper(AllhomesAgencySearchResults);
export { AllhomesAgencySearchResults as BaseAllhomesAgencySearchResults };